import { Meta } from '@/components/common';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/shared/ui/card';
import { Logo } from '@/shared/ui/logo';

/**
 * What somebody sees if they type the bare domain in.
 *
 * There is nothing to offer them here - no sign-in, no directory, no way to
 * find a design. The page exists so the root is not a 404, and so the person
 * reading it understands they need the link rather than an account.
 */
export function LandingPage() {
  return (
    <>
      <Meta title="Crown review" />

      <div className="flex min-h-dvh items-center justify-center bg-background px-4">
        <Card className="w-full max-w-md">
          <CardHeader className="space-y-3 text-center">
            <div className="flex justify-center">
              <Logo />
            </div>
            <CardTitle>Crown review</CardTitle>
            <CardDescription className="leading-relaxed">
              Dental labs use this page to send crown designs to dentists for approval. Designs open
              from the link in the email - there is no account to sign in to.
            </CardDescription>
          </CardHeader>
          <CardContent className="text-center text-sm text-muted-foreground">
            If you were expecting a design, open the link your lab emailed you. If the link has
            expired, they can send another.
          </CardContent>
        </Card>
      </div>
    </>
  );
}
